import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import { ButtonFrames } from '~/components/ButtonFrames'
import { FramedButtonItem } from '~/components/FramedButtonItem'
import { studytips } from '~/shared/types/studyTips.types'
import { useGetStudyTipCategoriesQuery } from '~/study-tips/apis/studyTips.api'

import ROUTES from '~/shared/constants/routes.const'

const StudyTipsPage: NextPage = (): React.ReactElement => {
  const { locale, isFallback } = useRouter()
  const { t } = useTranslation('studyTips')

  // If the page is not yet generated, router.isFallback will be true
  // initially until getStaticProps() finishes running
  const { data: studyTipsData } = useGetStudyTipCategoriesQuery({ language: locale as string }, { skip: isFallback })

  const tipsList = studyTipsData?.map((tips: studytips) => (
    <FramedButtonItem image={tips.icon} key={tips.key} name={tips.name} path={`${ROUTES.STUDY_TIPS}/${tips.key}`} />
  ))

  const style = {
    backgroundSize: '42.5%',
  }

  return (
    <div className="min-h-screen py-8 px-4 lg:px-8 sm:px-16" style={style}>
      <section className="max-w-3xl mx-auto">
        <ButtonFrames description={t('description')} title={t('title')}>
          {tipsList}
        </ButtonFrames>
      </section>
    </div>
  )
}

export default StudyTipsPage
